import { KlevuConfig } from '@klevu/core';

export const hasStatisticsConsent = (): boolean => window.Cookiebot?.consent?.statistics === true;

let consentListenersRegistered = false;

export const initKlevuConfig = (): void => {
  if (!window._KlevuConfig?.url || !window._KlevuConfig?.apiKey) {
    return;
  }

  if (!KlevuConfig.default) {
    KlevuConfig.init({
      url: window._KlevuConfig.url,
      apiKey: window._KlevuConfig.apiKey,
      useConsent: true,
      consentGiven: hasStatisticsConsent(),
    });
  }

  if (!consentListenersRegistered) {
    const updateKlevuConsent = () => KlevuConfig.default?.setConsentGiven(hasStatisticsConsent());
    ['CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline'].forEach((e) =>
      window.addEventListener(e, updateKlevuConsent)
    );
    consentListenersRegistered = true;
  }
};
